/* KSX – small behaviours for the K-beauty sections */
(function () {
  if (window.__ksx) return;
  window.__ksx = true;
  var KSX_CONFIG = window.KSX_LOCALE || {};
  var rtl = document.documentElement.dir === 'rtl';
  var rootUrl = (KSX_CONFIG.root || '/').replace(/\/?$/, '/');
  function t(value) { return (window.KSX_I18N || {})[value] || value; }
  function countText(value) { return t('Number of items: {{ count }}').replace('__KSX_COUNT__', value); }


  function money(cents) {
    if (KSX_CONFIG.currency && window.Intl) {
      try { return new Intl.NumberFormat(KSX_CONFIG.language === 'ar' ? 'ar-SA-u-nu-latn' : (KSX_CONFIG.language || 'en'), { style: 'currency', currency: KSX_CONFIG.currency }).format((cents || 0) / 100); } catch (e) {}
    }
    var fmt = (window.KSX_CART && window.KSX_CART.moneyFormat) || '${{amount}}';
    var n = (cents || 0) / 100;
    function fixed(d, t, dec) {
      var parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fixed(0, ',', '.');
      if (k === 'amount_with_comma_separator') return fixed(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fixed(0, '.', ',');
      return fixed(2, ',', '.');
    });
  }

  function toast(html) {
    var t = document.querySelector('.ksx-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'ksx-toast';
      document.body.appendChild(t);
    }
    t.innerHTML = html;
    t.classList.add('is-show');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-show'); }, 3200);
  }

  function refreshCount() {
    fetch(rootUrl + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-ksx-count], .cart-count, .site-header__cart-count').forEach(function (el) {
        if (el.hasAttribute('data-ksx-count')) {
          el.textContent = c.item_count;
          el.hidden = c.item_count === 0;
        }
      });
    }).catch(function () {});
  }

  function initSlideshow(root) {
    var track = root.querySelector('.ksx-slides__track');
    var slides = track ? track.children : [];
    if (!track || slides.length < 2) return;
    var dots = root.querySelectorAll('.ksx-dots button');
    var i = 0;
    var delay = parseInt(root.dataset.autoplay || '0', 10) * 1000;
    var timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + ((rtl ? 100 : -100) * i) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function play() { if (delay) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, delay); } }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    var p = root.querySelector('.ksx-arrow--prev'), nx = root.querySelector('.ksx-arrow--next');
    if (p) p.addEventListener('click', function () { go(i - 1); play(); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); play(); });
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1) * (rtl ? -1 : 1)); play(); }
      x0 = null;
    });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', play);
    play();
  }

  // Hide product cards whose product already appeared higher on the page
  // (slides, banners, category circles or earlier cards). Each tab panel is
  // deduped against what came before the tabs; only the first panel counts
  // toward sections further down.
  function dedupe() {
    var seen = {};
    var bases = new Map();   // tabs wrapper -> snapshot of "seen" before it
    var sets = new Map();    // panel -> ids already shown in that panel
    document.querySelectorAll("main [data-ksx-pid]").forEach(function (el) {
      if (!el.isConnected) return;
      var pick = el.parentNode.hasAttribute && el.parentNode.hasAttribute("data-ksx-pick") ? el.parentNode : null;
      if (pick) {
        // choose the first candidate image not already shown on the page
        var imgs = Array.prototype.slice.call(pick.children).filter(function (c) { return c.hasAttribute("data-ksx-pid"); });
        var keep = imgs.filter(function (c) { return !seen[c.getAttribute("data-ksx-pid")]; })[0] || imgs[0];
        imgs.forEach(function (c) { if (c !== keep) c.remove(); });
        seen[keep.getAttribute("data-ksx-pid")] = 1;
        return;
      }
      var id = el.getAttribute("data-ksx-pid");
      var isCard = el.classList.contains("ksx-card");
      var panel = el.closest(".ksx-panel");
      if (!panel) {
        if (isCard && seen[id]) { el.remove(); return; }
        seen[id] = 1;
        return;
      }
      var wrap = panel.parentNode;
      if (!bases.has(wrap)) bases.set(wrap, Object.assign({}, seen));
      if (!sets.has(panel)) sets.set(panel, Object.assign({}, bases.get(wrap)));
      var own = sets.get(panel);
      if (isCard && own[id]) { el.remove(); return; }
      own[id] = 1;
      if (panel === wrap.querySelector(".ksx-panel")) seen[id] = 1;
    });
  }

  /* ---------- swipe rows: progress bar + arrow states ---------- */
  function scrollerFor(bar) {
    var row = bar.closest('.ksx-row');
    if (row) return row.querySelector('.ksx-row__track');
    return bar.previousElementSibling;
  }
  function updateProgress(bar, sc) {
    var max = sc.scrollWidth - sc.clientWidth;
    var ratio = sc.scrollWidth ? sc.clientWidth / sc.scrollWidth : 1;
    bar.classList.toggle('is-hidden', max <= 2 || sc.clientWidth === 0);
    var thumb = bar.firstElementChild;
    var w = Math.max(ratio * 100, 12);
    thumb.style.width = w + '%';
    var pos = max > 0 ? Math.abs(sc.scrollLeft) / max : 0;
    thumb.style.transform = 'translateX(' + ((rtl ? -1 : 1) * pos * (100 / w * 100 - 100)) + '%)';
    var row = sc.closest('.ksx-row');
    if (row) {
      var prev = row.querySelector('.ksx-arrow--prev'), next = row.querySelector('.ksx-arrow--next');
      if (prev) prev.disabled = Math.abs(sc.scrollLeft) <= 2;
      if (next) next.disabled = Math.abs(sc.scrollLeft) >= max - 2;
    }
  }
  function initProgress(scope) {
    (scope || document).querySelectorAll('[data-ksx-progress]').forEach(function (bar) {
      var sc = scrollerFor(bar);
      if (!sc) return;
      if (!sc._ksxBound) {
        sc._ksxBound = true;
        sc.addEventListener('scroll', function () { updateProgress(bar, sc); }, { passive: true });
        window.addEventListener('resize', function () { updateProgress(bar, sc); });
      }
      updateProgress(bar, sc);
    });
  }

  /* ---------- cart drawer ---------- */
  var cartEl = function () { return document.getElementById('KsxCart'); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function shippingAmount(value, currency, estimated) {
    var digits = estimated ? 1 : 2;
    var rounded = estimated ? Math.ceil(value * 10 - 0.0000001) / 10 : value;
    try {
      return new Intl.NumberFormat(KSX_CONFIG.language === 'ar' ? 'ar-SA-u-nu-latn' : (KSX_CONFIG.language || 'en'), {
        style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: digits
      }).format(rounded);
    } catch (e) { return currency + ' ' + rounded.toFixed(digits); }
  }

  function shippingText(el, name) {
    var template = el.querySelector('[data-ksx-shipping-' + name + ']');
    return template && template.content ? template.content.textContent.trim() : '';
  }

  function shippingMessage(el, text, amount) {
    var message = el.querySelector('[data-ksx-shipping-message]');
    var parts = text.split('__AMOUNT__');
    message.textContent = parts[0];
    if (parts.length > 1) {
      var highlight = document.createElement('bdi');
      highlight.className = 'ksx-shipping-progress__amount';
      highlight.textContent = amount;
      message.appendChild(highlight);
      message.appendChild(document.createTextNode(parts.slice(1).join('__AMOUNT__')));
    }
  }

  function updateShippingProgress(cart) {
    document.querySelectorAll('[data-ksx-shipping]').forEach(function (el) {
      var currency = cart.currency || el.dataset.currency;
      var threshold = Number(el.dataset.threshold);
      var total = Number(cart.total_price);
      el.hidden = !threshold || currency !== el.dataset.currency || !cart.item_count || cart.requires_shipping === false;
      if (el.hidden) return;
      var remaining = Math.max(0, threshold - total);
      var estimated = el.dataset.estimate === 'true';
      var displayCurrency = el.dataset.displayCurrency;
      var displayRate = Number(el.dataset.displayRate) || 1;
      var amount = shippingAmount(remaining / 100 * displayRate, displayCurrency, estimated);
      shippingMessage(el, shippingText(el, remaining ? 'remaining' : 'unlocked'), amount);
      el.querySelector('progress').value = Math.min(100, Math.max(0, total / threshold * 100));
      el.querySelector('[data-ksx-shipping-goal]').textContent = shippingText(el, 'goal-template')
        .replace('__AMOUNT__', shippingAmount(Number(el.dataset.displayTarget), displayCurrency, false));
      var exact = el.querySelector('[data-ksx-shipping-exact]');
      if (exact) exact.textContent = shippingText(el, 'exact-template')
        .replace('__AMOUNT__', shippingAmount(threshold / 100, currency, false));
      el.classList.toggle('is-unlocked', remaining === 0);
    });
  }

  function renderCart(cart) {
    if (cart.currency) KSX_CONFIG.currency = cart.currency;
    updateShippingProgress(cart);
    var root = cartEl();
    if (!root) return;
    var items = root.querySelector('[data-ksx-cart-items]');
    var empty = root.querySelector('[data-ksx-cart-empty]');
    var foot = root.querySelector('[data-ksx-cart-foot]');
    root.querySelector('[data-ksx-cart-count]').textContent = countText(cart.item_count);
    root.querySelector('[data-ksx-cart-subtotal]').textContent = money(cart.total_price);
    empty.hidden = cart.item_count > 0;
    foot.hidden = cart.item_count === 0;
    items.innerHTML = cart.items.map(function (it, i) {
      var line = i + 1;
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="ksx-cd__variant">' + esc(it.variant_title) + '</div>' : '';
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<div class="ksx-cd__item" data-line="' + line + '">' +
        '<a class="ksx-cd__thumb" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 200)) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div class="ksx-cd__info">' +
          (it.vendor ? '<div class="ksx-cd__vendor">' + esc(it.vendor) + '</div>' : '') +
          '<a class="ksx-cd__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="ksx-cd__qty">' +
            '<button type="button" data-ksx-qty="' + (it.quantity - 1) + '" data-line="' + line + '" aria-label="' + esc(t("Decrease quantity")) + '">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-ksx-qty="' + (it.quantity + 1) + '" data-line="' + line + '" aria-label="' + esc(t("Increase quantity")) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="ksx-cd__side">' +
          '<div class="ksx-cd__price">' + was + money(it.final_line_price) + '</div>' +
          '<button type="button" class="ksx-cd__remove" data-ksx-qty="0" data-line="' + line + '">' + esc(t("Remove")) + '</button>' +
        '</div>' +
      '</div>';
    }).join('');
    document.querySelectorAll('[data-ksx-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    loadReco(cart);
  }

  var recoFor = null;
  function loadReco(cart) {
    var root = cartEl();
    var box = root.querySelector('[data-ksx-cart-reco]');
    var list = root.querySelector('[data-ksx-cart-reco-list]');
    if (!cart.items.length) { box.hidden = true; recoFor = null; return; }
    var pid = cart.items[0].product_id;
    if (pid === recoFor) return;
    recoFor = pid;
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
    var url = (window.KSX_CART && window.KSX_CART.recoUrl || '/recommendations/products') + '.json?product_id=' + pid + '&limit=8&intent=related';
    fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      var picks = (d.products || []).filter(function (p) { return !inCart[p.id] && p.available; }).slice(0, 6);
      box.hidden = picks.length === 0;
      list.innerHTML = picks.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        var single = p.variants.length === 1;
        var was = p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
        return '<div class="ksx-cd__reco-item">' +
          '<img src="' + esc(sized(p.featured_image, 160)) + '" alt="' + esc(p.title) + '" loading="lazy">' +
          '<div><a href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="p">' + was + money(p.price) + '</div>' +
          (single ? '<button type="button" class="ksx-cd__reco-add" data-ksx-add="' + v.id + '">' + esc(t("+ Add")) + '</button>' : '<a class="ksx-cd__reco-add" href="' + esc(p.url) + '">' + esc(t("Options")) + '</a>') +
          '</div></div>';
      }).join('');
    }).catch(function () { box.hidden = true; });
  }

  function fetchCart() {
    return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function openCart() {
    if (typeof wlClose === 'function') wlClose();
    if (typeof acctClose === 'function') acctClose();
    var root = cartEl();
    if (!root) { window.location.href = rootUrl + 'cart'; return; }
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    fetchCart().then(renderCart);
  }
  function closeCart() {
    var root = cartEl();
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function changeLine(line, qty) {
    var row = cartEl().querySelector('.ksx-cd__item[data-line="' + line + '"]');
    if (row) row.classList.add('is-busy');
    fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.status && cart.description) { toast(esc(cart.description)); return fetchCart().then(renderCart); }
      renderCart(cart);
    }).catch(function () { if (row) row.classList.remove('is-busy'); });
  }
  function addToCart(btn) {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-ksx-add'), 10), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || t("Could not add to cart"));
        btn.classList.remove('is-loading');
        var label = btn.querySelector('.ksx-atc__label');
        if (label) {
          btn.classList.add('is-added');
          var old = label.textContent;
          label.textContent = t("Added");
          setTimeout(function () { btn.classList.remove('is-added'); label.textContent = old; }, 1600);
        }
        document.dispatchEvent(new CustomEvent('ksx:cart-updated'));
        openCart();
      })
      .catch(function (err) { btn.classList.remove('is-loading'); toast(esc(err.message)); });
  }

  /* ---------- wishlist (shares the theme's "wishListsArr" of product handles) ---------- */
  var WL_KEY = 'wishListsArr';
  function wlGet() {
    try { var a = JSON.parse(localStorage.getItem(WL_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function wlSet(a) { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch (e) {} }
  function wlSync() {
    var list = wlGet();
    document.querySelectorAll('[data-ksx-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-ksx-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
      b.setAttribute('aria-label', on ? t("Remove from wishlist") : t("Add to wishlist"));
    });
    document.querySelectorAll('[data-ksx-wish-badge]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }
  function wlToggle(handle, btn) {
    var list = wlGet();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); toast(t("Removed from wishlist")); }
    else {
      list.push(handle);
      toast(esc(t(t("Saved to wishlist"))) + '<a href="#" data-ksx-wish-open>' + esc(t(t("View"))) + '</a>');
      if (btn) { btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop'); }
    }
    wlSet(list);
    wlSync();
    var d = document.getElementById('KsxWish');
    if (d && d.classList.contains('is-open')) wlRender();
  }
  function wlRender() {
    var d = document.getElementById('KsxWish');
    if (!d) return;
    var list = wlGet();
    var box = d.querySelector('[data-ksx-wish-items]');
    d.querySelector('[data-ksx-wish-count]').textContent = countText(list.length);
    d.querySelector('[data-ksx-wish-empty]').hidden = list.length > 0;
    if (!list.length) { box.innerHTML = ''; return; }
    Promise.all(list.map(function (h) {
      return fetch(rootUrl + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      box.innerHTML = products.map(function (p, i) {
        if (!p) return '';
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];
        var single = p.variants.length === 1;
        var was = p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
        var action = !p.available ? '<span class="ksx-cd__reco-add is-off">' + esc(t("Sold out")) + '</span>'
          : single ? '<button type="button" class="ksx-cd__reco-add" data-ksx-add="' + v.id + '">' + esc(t("+ Add to cart")) + '</button>'
          : '<a class="ksx-cd__reco-add" href="' + esc(p.url) + '">' + esc(t("Choose options")) + '</a>';
        return '<div class="ksx-cd__item">' +
          '<a class="ksx-cd__thumb" href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(sized(p.featured_image, 200)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<div class="ksx-cd__info">' +
            (p.vendor ? '<div class="ksx-cd__vendor">' + esc(p.vendor) + '</div>' : '') +
            '<a class="ksx-cd__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<div class="ksx-cd__price" style="text-align:left">' + was + money(p.price) + '</div>' + action +
          '</div>' +
          '<div class="ksx-cd__side"><button type="button" class="ksx-cd__remove" data-ksx-wish-remove="' + esc(list[i]) + '">' + esc(t("Remove")) + '</button></div>' +
        '</div>';
      }).join('');
    });
  }
  function acctOpen() {
    var d = document.getElementById('KsxAccount');
    if (!d) { window.location.href = '/account'; return; }
    closeCart(); wlClose();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function acctClose() {
    var d = document.getElementById('KsxAccount');
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function wlOpen() {
    var d = document.getElementById('KsxWish');
    if (!d) return;
    closeCart();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    wlRender();
  }
  function wlClose() {
    var d = document.getElementById('KsxWish');
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  /* ---------- drag-to-scroll for mouse users (cart suggestions) ---------- */
  function enableDrag(el) {
    if (!el || el._ksxDrag) return;
    el._ksxDrag = true;
    var down = false, x0 = 0, s0 = 0, moved = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; x0 = e.clientX; s0 = el.scrollLeft;
      el.style.scrollSnapType = 'none';
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - x0;
      if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = s0 - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      el.style.scrollSnapType = '';
    });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }

  /* ---------- 3D product stage on banners ---------- */
  function initTilt(scope) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    (scope || document).querySelectorAll('.ksx-banner--fallback').forEach(function (card) {
      if (card._ksxTilt) return;
      card._ksxTilt = true;
      var stage = card.querySelector('.ksx-banner__stage');
      if (!stage) return;
      card.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - (r.left + r.width / 2)) / r.width;
        var y = (e.clientY - (r.top + r.height / 2)) / r.height;
        stage.style.setProperty('--rx', (-y * 16).toFixed(2) + 'deg');
        stage.style.setProperty('--ry', (x * 22).toFixed(2) + 'deg');
      });
      card.addEventListener('pointerleave', function () {
        stage.style.setProperty('--rx', '0deg');
        stage.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- product page ---------- */
  function initPdp(scope) {
    (scope || document).querySelectorAll('[data-ksx-pdp]').forEach(function (root) {
      if (root._ksxPdp) return;
      root._ksxPdp = true;
      var dataEl = root.querySelector('[data-ksx-product-json]');
      var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [], start: 0 };
      var slides = root.querySelector('[data-ksx-pdp-slides]');
      var count = slides ? slides.children.length : 0;
      var idx = 0;

      function show(n, smooth) {
        if (!slides || !count) return;
        idx = (n + count) % count;
        slides.scrollTo({ left: (rtl ? -1 : 1) * slides.clientWidth * idx, behavior: smooth === false ? 'auto' : 'smooth' });
        mark();
      }
      function mark() {
        root.querySelectorAll('.ksx-pdp__dots button').forEach(function (b, k) { b.classList.toggle('is-active', k === idx); });
        root.querySelectorAll('.ksx-pdp__thumb').forEach(function (b, k) { b.classList.toggle('is-active', k === idx); });
        var t = root.querySelectorAll('.ksx-pdp__thumb')[idx];
        if (t) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      if (slides) {
        var st;
        slides.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(function () {
            var n = Math.round(Math.abs(slides.scrollLeft) / Math.max(1, slides.clientWidth));
            if (n !== idx) { idx = n; mark(); }
          }, 80);
        }, { passive: true });
        requestAnimationFrame(function () { show(data.start || 0, false); });
        setTimeout(function () { show(data.start || 0, false); }, 60);
      }
      root.addEventListener('click', function (e) {
        var go = e.target.closest('[data-ksx-pdp-go]');
        if (go) { show(idx + parseInt(go.getAttribute('data-ksx-pdp-go'), 10)); return; }
        var to = e.target.closest('[data-ksx-pdp-to]');
        if (to) { show(parseInt(to.getAttribute('data-ksx-pdp-to'), 10)); return; }
        var step = e.target.closest('[data-ksx-step]');
        if (step) {
          var input = root.querySelector('.ksx-qty input');
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-ksx-step'), 10));
        }
      });

      // variants
      var form = root.querySelector('[data-ksx-product-form]');
      function selected() {
        var vals = [];
        root.querySelectorAll('[data-ksx-opt]:checked').forEach(function (i) { vals[parseInt(i.getAttribute('data-ksx-opt'), 10)] = i.value; });
        return vals;
      }
      function applyVariant() {
        var vals = selected();
        var v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return vals[i] === undefined || o === vals[i]; }); })[0];
        vals.forEach(function (val, i) { var l = root.querySelector('[data-ksx-opt-label="' + i + '"]'); if (l) l.textContent = val; });
        var btn = root.querySelector('[data-ksx-pdp-add]');
        var sticky = root.querySelector('[data-ksx-sticky-add]');
        var label = btn.querySelector('.ksx-atc__label');
        if (!v) {
          btn.disabled = true; label.textContent = t("Unavailable");
          if (sticky) { sticky.disabled = true; sticky.querySelector('.ksx-atc__label').textContent = t("Unavailable"); }
          return;
        }
        root.querySelector('[data-ksx-variant-id]').value = v.id;
        root.querySelectorAll('[data-ksx-price-now]').forEach(function (el) { el.textContent = money(v.price); });
        var sale = v.compare_at_price > v.price;
        var was = root.querySelector('[data-ksx-price-was]');
        was.hidden = !sale; if (sale) was.textContent = money(v.compare_at_price);
        var save = root.querySelector('[data-ksx-price-save]');
        save.hidden = !sale; if (sale) save.textContent = t("Save ") + money(v.compare_at_price - v.price);
        root.querySelector('[data-ksx-price-now]').classList.toggle('is-sale', sale);
        btn.disabled = !v.available; label.textContent = v.available ? t('Add to cart') : t("Sold out");
        if (sticky) { sticky.disabled = !v.available; sticky.querySelector('.ksx-atc__label').textContent = v.available ? t('Add to cart') : t("Sold out"); }
        var stock = root.querySelector('[data-ksx-stock]');
        stock.innerHTML = v.available ? '<span class="is-in"></span>' + esc(t("In stock \u2014 ready to ship")) : '<span class="is-out"></span>' + esc(t("Currently out of stock"));
        if (v.media_id) {
          var s = root.querySelector('.ksx-pdp__slide[data-media-id="' + v.media_id + '"]');
          if (s) show(Array.prototype.indexOf.call(slides.children, s));
        }
        if (history.replaceState) {
          var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
        }
      }
      root.querySelectorAll('[data-ksx-opt]').forEach(function (i) { i.addEventListener('change', applyVariant); });

      // add to cart -> drawer
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = root.querySelector('[data-ksx-pdp-add]');
          if (btn.disabled || btn.classList.contains('is-loading')) return;
          btn.classList.add('is-loading');
          var qty = parseInt(root.querySelector('.ksx-qty input').value, 10) || 1;
          fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(root.querySelector('[data-ksx-variant-id]').value, 10), quantity: qty }] })
          }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              btn.classList.remove('is-loading');
              if (!res.ok) throw new Error(res.j.description || t("Could not add to cart"));
              openCart();
            })
            .catch(function (err) { btn.classList.remove('is-loading'); toast(esc(err.message)); });
        });
      }
      var stickyBtn = root.querySelector('[data-ksx-sticky-add]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });

      // sticky bar appears once the main button scrolls away
      var bar = root.querySelector('[data-ksx-sticky-buy]');
      var main = root.querySelector('.ksx-pdp__buy');
      if (bar && main && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var off = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', off);
          bar.setAttribute('aria-hidden', !off);
        }).observe(main);
      }

      // description: tidy supplier markup into clean typography
      var rte = root.querySelector('[data-ksx-rte]');
      if (rte) {
        rte.querySelectorAll('[style]').forEach(function (el) { el.removeAttribute('style'); });
        rte.querySelectorAll('p').forEach(function (p) {
          if (!p.textContent.trim() && !p.querySelector('img,iframe')) p.remove();
        });
        rte.querySelectorAll('p > strong:only-child, p > b:only-child').forEach(function (s) {
          var p = s.parentNode;
          if (p.textContent.trim() === s.textContent.trim() && s.textContent.length < 70) {
            var h = document.createElement('h4'); h.textContent = s.textContent.replace(/:$/, ''); p.replaceWith(h);
          }
        });
        rte.querySelectorAll('table').forEach(function (t) {
          if (!t.parentNode.classList.contains('ksx-rte__table')) {
            var w = document.createElement('div'); w.className = 'ksx-rte__table'; t.parentNode.insertBefore(w, t); w.appendChild(t);
          }
        });
      }
    });
  }

  /* ---------- predictive search ---------- */
  var RS_KEY = 'ksxRecentSearches';
  function rsGet() { try { var a = JSON.parse(localStorage.getItem(RS_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function rsAdd(q) {
    q = (q || '').trim();
    if (!q) return;
    var a = rsGet().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    a.unshift(q);
    try { localStorage.setItem(RS_KEY, JSON.stringify(a.slice(0, 6))); } catch (e) {}
  }
  function hl(text, q) {
    var safe = esc(text);
    var words = (q || '').trim().split(/\s+/).filter(function (w) { return w.length > 1; })
      .map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!words.length) return safe;
    return safe.replace(new RegExp('(' + words.join('|') + ')', 'ig'), '<mark>$1</mark>');
  }
  function priceCents(v) {
    if (v == null || v === '') return 0;
    // predictive search returns decimal amounts, e.g. "77.00"
    var n = parseFloat(String(v).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function initSearch(scope) {
    (scope || document).querySelectorAll('[data-ksx-search]').forEach(function (wrap) {
      if (wrap._ksxSearch) return;
      wrap._ksxSearch = true;
      var input = wrap.querySelector('[data-ksx-search-input]');
      var form = wrap.querySelector('form');
      var panel = wrap.querySelector('[data-ksx-search-panel]');
      var idle = wrap.querySelector('[data-ksx-search-idle]');
      var results = wrap.querySelector('[data-ksx-search-results]');
      var clear = wrap.querySelector('[data-ksx-search-clear]');
      var recentWrap = wrap.querySelector('[data-ksx-search-recent-wrap]');
      var recentBox = wrap.querySelector('[data-ksx-search-recent]');
      var timer, ctrl, active = -1, lastQ = '';
      var searchUrl = form.getAttribute('action') || '/search';

      function open() {
        // on small screens the panel is fixed; pin it just under the search box
        if (window.innerWidth < 990) {
          var r = form.getBoundingClientRect();
          panel.style.top = Math.round(r.bottom + 8) + 'px';
          panel.style.maxHeight = Math.max(240, window.innerHeight - r.bottom - 24) + 'px';
        } else {
          panel.style.top = '';
          panel.style.maxHeight = '';
        }
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        wrap.classList.add('is-open');
        document.documentElement.classList.add('ksx-search-open');
      }
      function close() {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        wrap.classList.remove('is-open');
        document.documentElement.classList.remove('ksx-search-open');
        active = -1;
      }
      function renderRecent() {
        var a = rsGet();
        recentWrap.hidden = !a.length;
        recentBox.innerHTML = a.map(function (q) {
          return '<a class="ksx-sr__chip" href="' + searchUrl + '?q=' + encodeURIComponent(q) + '&type=product" data-ksx-search-term="' + esc(q) + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/></svg>' + esc(q) + '</a>';
        }).join('');
      }
      function showIdle() { idle.hidden = false; results.hidden = true; renderRecent(); }
      function items() { return panel.querySelectorAll('[data-ksx-sr-item]'); }
      function move(d) {
        var list = items();
        if (!list.length) return;
        if (active > -1 && list[active]) list[active].classList.remove('is-active');
        active = (active + d + list.length) % list.length;
        list[active].classList.add('is-active');
        list[active].scrollIntoView({ block: 'nearest' });
      }

      function render(q, data) {
        var r = (data && data.resources && data.resources.results) || {};
        var products = r.products || [], collections = r.collections || [], queries = r.queries || [];
        var viewAll = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last';
        if (!products.length && !collections.length && !queries.length) {
          results.innerHTML = '<div class="ksx-sr__none"><strong>' + esc(t("No results for \u201c")) + '' + esc(q) + '”</strong><span>' + esc(t("Check the spelling or try a brand, product type or ingredient.")) + '</span></div>';
          return;
        }
        var html = '<div class="ksx-sr__grid">';
        html += '<div class="ksx-sr__aside">';
        if (queries.length) {
          html += '<div class="ksx-sr__block"><div class="ksx-sr__head"><h4>' + esc(t("Suggestions")) + '</h4></div><ul class="ksx-sr__list">' +
            queries.slice(0, 5).map(function (s) {
              return '<li><a data-ksx-sr-item data-ksx-search-term="' + esc(s.text) + '" href="' + esc(s.url || (searchUrl + '?q=' + encodeURIComponent(s.text))) + '">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
                (s.styled_text || hl(s.text, q)) + '</a></li>';
            }).join('') + '</ul></div>';
        }
        if (collections.length) {
          html += '<div class="ksx-sr__block"><div class="ksx-sr__head"><h4>' + esc(t("Categories")) + '</h4></div><div class="ksx-sr__chips">' +
            collections.slice(0, 6).map(function (c) {
              return '<a data-ksx-sr-item class="ksx-sr__chip" href="' + esc(c.url) + '">' + hl(c.title, q) + '</a>';
            }).join('') + '</div></div>';
        }
        html += '</div>';
        html += '<div class="ksx-sr__main"><div class="ksx-sr__head"><h4>' + esc(t("Products")) + '</h4><span>' + countText(products.length) + '</span></div>';
        if (products.length) {
          html += '<ul class="ksx-sr__products">' + products.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
            var price = priceCents(p.price);
            var was = priceCents(p.compare_at_price_max);
            var sale = was > price;
            return '<li><a data-ksx-sr-item class="ksx-sr__product" href="' + esc(p.url) + '" data-ksx-search-term="' + esc(q) + '">' +
              '<span class="ksx-sr__thumb">' + (img ? '<img src="' + esc(sized(img, 160)) + '" alt="" loading="lazy">' : '') + '</span>' +
              '<span class="ksx-sr__meta">' +
                (p.vendor ? '<span class="ksx-sr__vendor">' + esc(p.vendor) + '</span>' : '') +
                '<span class="ksx-sr__title">' + hl(p.title, q) + '</span>' +
                '<span class="ksx-sr__price">' + (sale ? '<s>' + money(was) + '</s>' : '') + '<b' + (sale ? ' class="is-sale"' : '') + '>' + money(price) + '</b>' +
                  (p.available === false ? '<em>' + esc(t("Sold out")) + '</em>' : '') + '</span>' +
              '</span></a></li>';
          }).join('') + '</ul>';
        } else {
          html += '<p class="ksx-sr__muted">' + esc(t("No products match yet \u2014 try another word.")) + '</p>';
        }
        html += '</div></div>';
        html += '<a class="ksx-sr__all" data-ksx-sr-item data-ksx-search-term="' + esc(q) + '" href="' + esc(viewAll) + '">' + esc(t("View all results for \u201c")) + '' + esc(q) + '” <span aria-hidden="true">→</span></a>';
        results.innerHTML = html;
      }

      function query(q) {
        if (KSX_CONFIG.language === 'ar') {
          if (ctrl && ctrl.abort) ctrl.abort();
          idle.hidden = true; results.hidden = false; active = -1;
          var fullUrl = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last';
          results.innerHTML = '<a class="ksx-sr__all" data-ksx-sr-item href="' + esc(fullUrl) + '">' + esc(t('Search for “{{ terms }}”').replace('__KSX_TERMS__', q)) + '</a><p class="ksx-sr__muted">' + esc(t('Press Enter or tap to view matching products.')) + '</p>';
          return;
        }
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        results.innerHTML = '<div class="ksx-sr__loading"><span></span><span></span><span></span></div>';
        idle.hidden = true; results.hidden = false; active = -1;
        var url = rootUrl + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,query&resources[limit]=6' +
          '&resources[options][unavailable_products]=last&resources[options][fields]=title,vendor,product_type,tag,variants.title,variants.sku';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); })
          .then(function (d) { if (q === lastQ) render(q, d); })
          .catch(function (e) { if (e.name !== 'AbortError') results.innerHTML = '<div class="ksx-sr__none"><strong>' + esc(t("Search is unavailable")) + '</strong><span>' + esc(t("Press Enter to see full results.")) + '</span></div>'; });
      }

      input.addEventListener('focus', function () { if (!input.value.trim()) showIdle(); open(); });
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clear.hidden = !input.value;
        clearTimeout(timer);
        lastQ = q;
        open();
        if (q.length < 2) { showIdle(); return; }
        timer = setTimeout(function () { query(q); }, 180);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); open(); move(1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
        else if (e.key === 'Escape') { close(); input.blur(); }
        else if (e.key === t("Enter") && active > -1 && items()[active]) {
          e.preventDefault();
          var el = items()[active];
          rsAdd(el.getAttribute('data-ksx-search-term') || input.value);
          window.location.href = el.href;
        }
      });
      form.addEventListener('submit', function (e) {
        if (!input.value.trim()) { e.preventDefault(); input.focus(); return; }
        rsAdd(input.value);
      });
      clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; showIdle(); input.focus(); });
      panel.addEventListener('click', function (e) {
        var rc = e.target.closest('[data-ksx-search-recent-clear]');
        if (rc) { try { localStorage.removeItem(RS_KEY); } catch (x) {} renderRecent(); return; }
        var term = e.target.closest('[data-ksx-search-term]');
        if (term) rsAdd(term.getAttribute('data-ksx-search-term'));
      });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
      if (input.value) clear.hidden = false;
    });
  }

  /* ---------- Judge.me reviews grid -> single-row carousel with arrows ---------- */
  function initReviewRow() {
    document.querySelectorAll('.ksx-reviews-app').forEach(function (app) {
      var body = app.querySelector('.jdgm-grid-body');
      if (!body || body._ksxRow) return;
      if (!body.querySelector('.jdgm-review-card')) return; // wait until Judge.me has rendered cards
      body._ksxRow = true;
      body.classList.add('ksx-rv-track');
      var row = document.createElement('div');
      row.className = 'ksx-row ksx-rv';
      body.parentNode.insertBefore(row, body);
      row.appendChild(body);
      row.insertAdjacentHTML('beforeend',
        '<button type="button" class="ksx-arrow ksx-arrow--prev" aria-label="' + esc(t("Previous reviews")) + '"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="m15 18-6-6 6-6"/></svg></button>' +
        '<button type="button" class="ksx-arrow ksx-arrow--next" aria-label="' + esc(t("Next reviews")) + '"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg></button>' +
        '<div class="ksx-progress" data-ksx-progress aria-hidden="true"><span></span></div>');
      var go = function (d) { body.scrollBy({ left: (rtl ? -1 : 1) * d * body.clientWidth * 0.85, behavior: 'smooth' }); };
      row.querySelector('.ksx-arrow--prev').addEventListener('click', function () { go(-1); });
      row.querySelector('.ksx-arrow--next').addEventListener('click', function () { go(1); });
      var bar = row.querySelector('[data-ksx-progress]');
      var update = function () { updateProgress(bar, body); };
      body.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      enableDrag(body);
      update();
    });
  }

  /* ---------- before/after banners: one image at a time ---------- */
  // Scroll decides the state (before while the image sits in the lower part of the
  // screen, after once it passes the middle), with a small dead-zone so it never
  // flickers. Tapping Before/After takes over until the banner leaves the screen.
  var baEls = [];
  function baSet(el, state) {
    if (el.getAttribute('data-state') === state) return;
    el.setAttribute('data-state', state);
    el.querySelectorAll('[data-ba-set]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-ba-set') === state ? 'true' : 'false');
    });
  }
  function baUpdate() {
    var vh = window.innerHeight || 800;
    baEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) { el._baManual = false; return; }
      if (el._baManual) return;
      var mid = r.top + r.height / 2;
      if (mid < vh * 0.5) baSet(el, 'after');
      else if (mid > vh * 0.62) baSet(el, 'before');
    });
  }
  function baSchedule() { baUpdate(); }
  function initBA(scope) {
    (scope || document).querySelectorAll('[data-ksx-ba]').forEach(function (el) {
      if (baEls.indexOf(el) > -1) return;
      baEls.push(el);
      el.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ba-set]');
        if (!b) return;
        e.preventDefault();
        el._baManual = true;
        baSet(el, b.getAttribute('data-ba-set'));
      });
    });
    if (!initBA._bound && baEls.length) {
      initBA._bound = true;
      window.addEventListener('scroll', baSchedule, { passive: true });
      window.addEventListener('resize', baSchedule);
    }
    baUpdate();
  }

  /* ---------- product page: related products + recently viewed ---------- */
  var ICON_BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 8h14l-1 13H6L5 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  var ICON_HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 20s-7.5-4.6-9.3-9.2C1.5 7.6 3.6 4.5 7 4.5c2 0 3.6 1.2 5 3 1.4-1.8 3-3 5-3 3.4 0 5.5 3.1 4.3 6.3C19.5 15.4 12 20 12 20Z"/></svg>';

  // same markup as snippets/ksx-product-card.liquid, built from /products/<handle>.js
  function cardHtml(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
    var sale = p.compare_at_price > p.price;
    var pct = sale ? Math.floor((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
    var img2 = p.images && p.images[1] ? '<img src="' + esc(sized(p.images[1], 600)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
    var badge = !p.available ? '<span class="ksx-badge ksx-badge--soldout">' + esc(t("Sold out")) + '</span>'
      : sale ? '<span class="ksx-badge ksx-badge--sale">' + esc(t("Sale -")) + '' + pct + '%</span>' : '';
    var action = !p.available ? '<span class="ksx-atc is-disabled" aria-disabled="true">' + esc(t("Sold out")) + '</span>'
      : (p.variants || []).length === 1
        ? '<button type="button" class="ksx-atc" data-ksx-add="' + v.id + '"><span class="ksx-atc__icon">' + ICON_BAG + '</span><span class="ksx-atc__label">' + esc(t("Add to cart")) + '</span></button>'
        : '<a href="' + esc(p.url) + '" class="ksx-atc ksx-atc--ghost"><span class="ksx-atc__label">' + esc(t("Choose options")) + '</span></a>';
    return '<div class="ksx-card">' +
      '<a href="' + esc(p.url) + '" class="ksx-card__media" aria-label="' + esc(p.title) + '"><span class="ksx-badges">' + badge + '</span>' +
        (p.featured_image ? '<img src="' + esc(sized(p.featured_image, 600)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + img2 + '</a>' +
      (p.vendor ? '<div class="ksx-card__vendor">' + esc(p.vendor) + '</div>' : '') +
      '<a href="' + esc(p.url) + '" class="ksx-card__title">' + esc(p.title) + '</a>' +
      '<div class="ksx-card__price">' + (sale ? '<s>' + money(p.compare_at_price) + '</s><span class="is-sale">' : '<span>') +
        (p.price_varies ? t("From ") : '') + money(p.price) + '</span></div>' +
      '<div class="ksx-card__actions">' + action +
        '<button type="button" class="ksx-wish" data-ksx-wish="' + esc(p.handle) + '" aria-label="' + esc(t("Add to wishlist")) + '" aria-pressed="false">' + ICON_HEART + '</button></div>' +
    '</div>';
  }

  function initRelated(scope) {
    (scope || document).querySelectorAll('[data-ksx-related]').forEach(function (sec) {
      if (sec._ksxLoaded || sec.querySelector('.ksx-card')) return;
      sec._ksxLoaded = true;
      fetch(sec.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-ksx-related]');
        if (!fresh || !fresh.querySelector('.ksx-card')) { sec.hidden = true; return; }
        sec.innerHTML = fresh.innerHTML;
        initProgress(sec);
        wlSync();
      }).catch(function () { sec.hidden = true; });
    });
  }

  var RV_KEY = 'ksxRecent';
  function initRecent(scope) {
    (scope || document).querySelectorAll('[data-ksx-recent]').forEach(function (sec) {
      if (sec._ksxLoaded) return;
      sec._ksxLoaded = true;
      var current = sec.getAttribute('data-current');
      var limit = parseInt(sec.getAttribute('data-limit'), 10) || 8;
      var list = [];
      try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); if (!Array.isArray(list)) list = []; } catch (e) {}
      var show = list.filter(function (h) { return h && h !== current; }).slice(0, limit);
      if (current) {
        var next = [current].concat(list.filter(function (h) { return h !== current; })).slice(0, 16);
        try { localStorage.setItem(RV_KEY, JSON.stringify(next)); } catch (e) {}
      }
      if (!show.length) return;
      Promise.all(show.map(function (h) {
        return fetch(rootUrl + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        products = products.filter(Boolean);
        if (!products.length) return;
        sec.querySelector('[data-ksx-recent-track]').innerHTML = products.map(cardHtml).join('');
        sec.hidden = false;
        initProgress(sec);
        wlSync();
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    if (scope === document) {
      dedupe();
      var shipping = document.querySelector('[data-ksx-shipping]');
      if (shipping) updateShippingProgress({total_price: Number(shipping.dataset.cartTotal), item_count: Number(shipping.dataset.itemCount), requires_shipping: shipping.dataset.requiresShipping === 'true', currency: shipping.dataset.cartCurrency || shipping.dataset.currency});
    }
    scope.querySelectorAll('[data-ksx-slideshow]').forEach(initSlideshow);
    initProgress(scope);
    initPdp(scope);
    initTilt(scope);
    wlSync();
    initSearch(scope);
    initReviewRow();
    initBA(scope);
    initRelated(scope);
    initRecent(scope);
    enableDrag(document.querySelector('[data-ksx-cart-reco-list]'));
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    var arrow = t.closest('[data-ksx-scroll]');
    if (arrow) {
      var row = arrow.closest('.ksx-row').querySelector('.ksx-row__track');
      var dir = arrow.dataset.ksxScroll === 'prev' ? -1 : 1;
      row.scrollBy({ left: (rtl ? -1 : 1) * dir * row.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }

    var tab = t.closest('.ksx-tab');
    if (tab) {
      var wrap = tab.closest('[data-ksx-tabs]');
      wrap.querySelectorAll('.ksx-tab').forEach(function (b) {
        var on = b === tab;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on);
      });
      wrap.querySelectorAll('.ksx-panel').forEach(function (p) { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
      initProgress(wrap);
      return;
    }

    var add = t.closest('[data-ksx-add]');
    if (add) {
      e.preventDefault();
      addToCart(add);
      return;
    }

    if (t.closest('[data-ksx-cart-open]') && document.getElementById('KsxCart')) {
      e.preventDefault();
      openCart();
      return;
    }
    if (t.closest('[data-ksx-cart-close]')) { closeCart(); return; }

    var wish = t.closest('[data-ksx-wish]');
    if (wish) { e.preventDefault(); wlToggle(wish.getAttribute('data-ksx-wish'), wish); return; }
    if (t.closest('[data-ksx-account-open]')) { e.preventDefault(); acctOpen(); return; }
    if (t.closest('[data-ksx-account-close]')) { acctClose(); return; }
    if (t.closest('[data-ksx-wish-open]')) { e.preventDefault(); acctClose(); wlOpen(); return; }
    if (t.closest('[data-ksx-wish-close]')) { wlClose(); return; }
    var wrm = t.closest('[data-ksx-wish-remove]');
    if (wrm) { wlToggle(wrm.getAttribute('data-ksx-wish-remove')); return; }

    var rgo = t.closest('[data-ksx-reco-go]');
    if (rgo) {
      var rl = document.querySelector('[data-ksx-cart-reco-list]');
      rl.scrollBy({ left: (rtl ? -1 : 1) * parseInt(rgo.getAttribute('data-ksx-reco-go'), 10) * rl.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }

    var qty = t.closest('[data-ksx-qty]');
    if (qty) { changeLine(qty.getAttribute('data-line'), parseInt(qty.getAttribute('data-ksx-qty'), 10)); return; }

    if (t.closest('[data-ksx-drawer-open]')) {
      document.querySelector('.ksx-drawer').classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      return;
    }
    if (t.closest('[data-ksx-drawer-close]')) {
      document.querySelector('.ksx-drawer').classList.remove('is-open');
      document.documentElement.style.overflow = '';
      return;
    }

    var more = t.closest('[data-ksx-more]');
    if (more) {
      var box = more.closest('.ksx-rich');
      box.classList.toggle('is-open');
      more.textContent = box.classList.contains('is-open') ? ((window.KSX_I18N || {})["Read less"] || "Read less") : ((window.KSX_I18N || {})["Read more"] || "Read more");
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); wlClose(); acctClose(); } });

  window.addEventListener('storage', function (e) { if (e.key === WL_KEY) wlSync(); });

  if (window.jQuery) {
    window.jQuery(document).ajaxComplete(function (event, xhr, settings) {
      if (['/cart/change.js', '/cart/update.js', '/cart/add.js'].some(function (path) { return (settings.url || '').split('?')[0].endsWith(path); })) {
        var cart = xhr.responseJSON;
        if (cart && Array.isArray(cart.items) && typeof cart.total_price === 'number') updateShippingProgress(cart);
        else fetchCart().then(updateShippingProgress).catch(function () {});
      }
    });
  }

  window.KSX = { money: money, toast: toast, refreshCount: refreshCount, init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Judge.me star icons rely on an icon font that renders as empty boxes in
  // this theme. Tag each icon with its state; CSS then draws a Unicode star.
  function fixStars() {
    if (document.getElementById('judgeme_product_reviews')) {
      document.querySelectorAll('a.jdgm-verified-count-badget[href="javascript:void(0)"]').forEach(function (el) {
        el.setAttribute('href', '#judgeme_product_reviews');
      });
    }
    document.querySelectorAll(".jm-star-rating__font-icon").forEach(function (el) {
      var g = el.textContent;
      var state = g === "" ? "empty" : g === "" ? "half" : "full";
      if (el.getAttribute("data-ksx-star") !== state) el.setAttribute("data-ksx-star", state);
    });
  }
  fixStars();
  if (window.MutationObserver) {
    var starTimer;
    new MutationObserver(function () {
      clearTimeout(starTimer);
      starTimer = setTimeout(function () { fixStars(); if (typeof initReviewRow === 'function') initReviewRow(); }, 60);
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

